module.exports = __webpack_public_path__ + "img/banner.54d2ce3a.png";